import { render, staticRenderFns } from "./editBasic.vue?vue&type=template&id=9523d932&scoped=true&lang=html&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./editBasic.vue?vue&type=style&index=0&id=9523d932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9523d932",
  null
  
)

export default component.exports